/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsPreview,
    MelcoModelsPreviewFromJSON,
    MelcoModelsPreviewFromJSONTyped,
    MelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsDesignCollectionDefaultDesign
 */
export interface MelcoModelsDesignCollectionDefaultDesign {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignCollectionDefaultDesign
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignCollectionDefaultDesign
     */
    name?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsPreview>}
     * @memberof MelcoModelsDesignCollectionDefaultDesign
     */
    previews?: Array<MelcoModelsPreview> | null;
}

export function MelcoModelsDesignCollectionDefaultDesignFromJSON(json: any): MelcoModelsDesignCollectionDefaultDesign {
    return MelcoModelsDesignCollectionDefaultDesignFromJSONTyped(json, false);
}

export function MelcoModelsDesignCollectionDefaultDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsDesignCollectionDefaultDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(MelcoModelsPreviewFromJSON)),
    };
}

export function MelcoModelsDesignCollectionDefaultDesignToJSON(value?: MelcoModelsDesignCollectionDefaultDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(MelcoModelsPreviewToJSON)),
    };
}


